import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { SuggestMobile } from '../../internal/components/SuggestMobile';
import { SuggestDesktop } from '../../internal/components/SuggestDesktop';
export var Suggest = function Suggest(props) {
  var deviceType = useDeviceType();
  var AdaptiveComponent = {
    phone: SuggestMobile,
    tablet: SuggestMobile,
    desktop: SuggestDesktop
  }[deviceType];
  return /*#__PURE__*/React.createElement(AdaptiveComponent, props);
};